
import { setWebviewAttr, setUser } from '@/util'
import queryString from 'query-string'
/**
 * 设置App的webview信息
 *
 * @export
 * @param {}
 */
export default function useSetWebView(webviewName ) {
  const pathName = window.location?.pathname
  const _webviewName = webviewName || pathName

  const search = window?.location.search
  const searchObj = queryString.parse(search) ?? {}
  if ( searchObj?.userToken ) {
    const userToken = decodeURIComponent(searchObj?.userToken)
    setUser({token:userToken})
  }
  // queryString
  console.log(  )
  setWebviewAttr(`{"name": "${_webviewName}"}`)
}
